module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section-liste-conges noselect",
    attrs: {
      "data-testid": "listeConges-section"
    }
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.sortedListAbsences,
      "stripe": "",
      "element-loading-text": "Chargement en cours...",
      "element-loading-spinner": "el-icon-loading",
      "element-loading-background": "rgba(255, 255, 255, 0.8)",
      "height": "100%",
      "border": "",
      "data-testid": "listeConges-table",
      "header-cell-class-name": "table-header"
    },
    on: {
      "sort-change": _vm.onSortChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "type",
      "label": "Type d'absence",
      "min-width": "440",
      "class-name": "cln-type",
      "sortable": "custom"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(_vm.getIcon(scope.row.codeType) == 'conge') ? _c('span', {
          staticClass: "icon-mask",
          style: ({
            backgroundColor: scope.row.couleur
          }),
          attrs: {
            "data-testid": "listeConges-absence-icon"
          }
        }) : _c('i', {
          class: _vm.getIcon(scope.row.codeType),
          style: ({
            color: scope.row.couleur
          }),
          attrs: {
            "data-testid": "listeConges-absence-icon"
          }
        }), _vm._v(" "), _c('span', {
          style: ({
            color: scope.row.couleur
          }),
          attrs: {
            "data-testid": "listeConges-absence-type",
            "title": scope.row.type
          }
        }, [_vm._v("\n                    " + _vm._s(scope.row.type) + "\n                ")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "dateDebut",
      "label": "Début",
      "min-width": "200",
      "width": "200",
      "class-name": "text-center",
      "sortable": "custom"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "dateFin",
      "label": "Fin",
      "min-width": "200",
      "width": "200",
      "class-name": "text-center",
      "sortable": "custom"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "duree",
      "label": "Durée",
      "min-width": "100",
      "width": "100",
      "class-name": "text-center",
      "sortable": "custom"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "statut",
      "label": "Statut",
      "min-width": "440",
      "class-name": "cln-statut",
      "sortable": "custom"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(_vm.getStatutDisplay(scope.row.statut)) ? _c('div', {
          staticClass: "header-info"
        }, [_c('div', {
          staticClass: "statut-pill",
          class: _vm.getStatutDisplay(scope.row.statut).classe,
          attrs: {
            "title": _vm.getStatutDisplay(scope.row.statut).description
          }
        }, [_c('i', {
          class: _vm.getStatutDisplay(scope.row.statut).icon
        }), _vm._v("\n                        " + _vm._s(_vm.getStatutDisplay(scope.row.statut).description) + "\n                    ")]), _vm._v(" "), _c('el-button', {
          staticClass: "historique",
          attrs: {
            "title": "Voir l'historique",
            "icon": "ri-zoom-in-line",
            "data-testid": "listeConges-pannel-button"
          },
          on: {
            "click": function($event) {
              _vm.openDrawerHistorique(scope.row)
            }
          }
        })], 1) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Actions",
      "class-name": "text-center",
      "min-width": "88"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "cln-action"
        }, [_c('el-button', {
          attrs: {
            "type": "text",
            "title": "Modifier",
            "disabled": !_vm.getActionsState(scope.row).modifierVisible || _vm.getActionsState(scope.row).modifierDisabled,
            "data-testid": "listeConges-modify-button"
          },
          on: {
            "click": function($event) {
              _vm.modify(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "ri-pencil-fill"
        })]), _vm._v(" "), (_vm.getActionsState(scope.row).supprimerDemandeAnnulationVisible) ? _c('el-button', {
          staticClass: "delete-cancel",
          attrs: {
            "type": "text",
            "title": "Supprimer la demande d'annulation",
            "data-testid": "listeConges-deleteCancellation-button"
          },
          on: {
            "click": function($event) {
              _vm.deleteCancellationRequest(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "ri-close-large-fill"
        })]) : _vm._e(), _vm._v(" "), (!_vm.getActionsState(scope.row).supprimerDemandeAnnulationVisible && _vm.getActionsState(scope.row).annulerVisible) ? _c('el-button', {
          staticClass: "cancel",
          attrs: {
            "type": "text",
            "title": "Annuler",
            "disabled": _vm.getActionsState(scope.row).annulerDisabled,
            "data-testid": "listeConges-cancel-button"
          },
          on: {
            "click": function($event) {
              _vm.cancel(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "ri-delete-bin-7-fill"
        })]) : _vm._e()], 1)]
      }
    }])
  })], 1), _vm._v(" "), (_vm.drawerIsVisible) ? _c('side-panel-historique', {
    attrs: {
      "absence": _vm.drawerAbsence
    },
    on: {
      "close": function($event) {
        _vm.drawerIsVisible = false
      }
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3b0b1d80"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/gestionDesAbsencesV2/listeConge/listeConge.vue.html
// module id = zkyQ
// module chunks = 2